module.exports = __webpack_public_path__ + "images/edge-new.jpg?b91a110d9e2c03f3a97654d335364dc4";